<template>
	<section
		class="container margin-auto margin-both-lg"
		:class="'columns-' + data.columns"
		v-if="data && data.content"
	>
		<HtmlContent class="no-padding" :html="data.content" />
		<HtmlContent v-if="data.columns && data.columns == 2" class="no-padding" :html="data.content_2" />
	</section>
</template>

<script>
import HtmlContent from '@/components/elements/HtmlContent'

export default {
	props: ['data'],
	components: {
		HtmlContent,
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-content_block {
	&.columns-2 {
		display: flex;
		flex-wrap: wrap;
		.html-content {
			max-width: 50%;
			width: 100%;
			&:first-child {
				padding-right: 25px;
			}
			&:nth-child(2) {
				padding-left: 25px;
			}
			@include mquery($phone) {
				max-width: 100%;
				padding-left: 0 !important;
				padding-right: 0 !important;
			}
		}
	}
}
</style>
